
<template>
  <div class="hello">
    <h1 v-if="!data">Laddar...</h1>
    <div>{{ data }}</div>
    <router-view></router-view>
  </div>
</template>

<script>
  const API_URL = 'http://carbonwhite-api.test/api/public/widgets'

  export default {
    name: 'Widget',
    data () {
      return {
        data: null,
        msg: 'Welcome to Your Vue.js App'
      }
    },
    created () {
      const slug = this.$route.params.slug
      this.load(slug)
    },
    methods: {
      load (slug) {
        fetch(`${API_URL}/${slug}`)
          .then((response) => response.json())
          .then((json) => {
            /*
            if (responseJson.sunstudies) {
              this.preloadSunstudies(responseJson.sunstudies.data).then(done => {
                this.setState({
                  data: responseJson
                })
              })
            }
            */

            this.data = json
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Overview.vue